import React from 'react'

interface Props {
    title: string
    subtitle?: React.ReactNode
}

function Title({ title, subtitle }: Props) {
    return <><h1>{title}</h1> 
    {subtitle && <div className="subtitle">{subtitle}</div>}</>
}

export default Title
